// Parses the inline shortcut syntax for fill-in-blanks (e.g. `bring/brought*`).
// See openspec/changes/add-fill-in-blanks-shortcut-syntax/specs/fill-in-blanks-editor/spec.md.

const VALID_MODES = new Set(["typing", "word_bank", "multiple_choice"])

function lex(innerString) {
  return innerString.split("/").map((raw) => {
    const trimmed = raw.trim()
    const correct = trimmed.endsWith("*")
    const text = correct ? trimmed.slice(0, -1).trim() : trimmed
    return { text, correct }
  })
}

function emptyEntry() {
  return { answer: "", alternatives: [], hint: "", options: [] }
}

export function parse(innerString, mode) {
  const safeMode = VALID_MODES.has(mode) ? mode : "typing"
  const tokens = lex(innerString || "")
  const nonEmpty = tokens.filter((t) => t.text.length > 0)

  if (nonEmpty.length === 0) {
    return emptyEntry()
  }

  if (safeMode === "typing") {
    const texts = nonEmpty.map((t) => t.text)
    return {
      answer: texts[0],
      alternatives: texts.slice(1),
      hint: "",
      options: [],
    }
  }

  if (safeMode === "word_bank") {
    return {
      answer: nonEmpty[0].text,
      alternatives: [],
      hint: "",
      options: [],
    }
  }

  // multiple_choice
  const options = nonEmpty.map((t) => t.text)
  const checked = nonEmpty.filter((t) => t.correct).map((t) => t.text)
  return {
    answer: checked[0] || "",
    alternatives: checked.slice(1),
    hint: "",
    options,
  }
}

export function isComplete(entry, mode) {
  if (!entry) return false
  const safeMode = VALID_MODES.has(mode) ? mode : "typing"

  if (safeMode === "multiple_choice") {
    const options = Array.isArray(entry.options) ? entry.options : []
    if (options.length < 2) return false
    const hasAnswer = (entry.answer || "").length > 0
    const hasAlt = Array.isArray(entry.alternatives) && entry.alternatives.length > 0
    return hasAnswer || hasAlt
  }

  return (entry.answer || "").length > 0
}
